"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = exports.combine = exports.variant = exports.oneOf = exports.tuple = exports.partial_obj = exports.obj = exports.array = exports.nullable = exports.optional = exports.uuid = exports.raw = exports.float = exports.int = exports.bool = exports.nothing = exports.str = exports.dateIso = exports.dateUnixMillis = exports.dateUnixSecs = exports.versioned = exports.validationError = exports.ValidationError = void 0;
/**
 * Type-safe, composable serialization/unserialization.
 *
 * Safe-portals can be used wherever data traverses an un-typed boundary
 * (eg from DB, tasks sent to resque, HTTP calls, routing information in
 * URLs), in order to maintain static analysis across the un-typed boundary.
 */
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(path, got) {
        var _this = _super.call(this) || this;
        _this.path = path;
        _this.got = got;
        _this.message = "data".concat(_this.path, " does not match serializer in data ").concat(JSON.stringify(_this.got));
        // needed because JS is silly
        // @ts-ignore
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
exports.ValidationError = ValidationError;
// why this wrapper with 'never' type? so we can put error handling into expressions
var validationError = function (path, got) {
    throw new ValidationError(path, got);
};
exports.validationError = validationError;
/**
 * Versioned serializable type, with data migrations.
 *
 * Serialized format is: [version: int, data: T]
 *
 * Version migrations operate on raw, unserialized data (see type of VersionMigrator)
 */
function versioned(args) {
    var inner = tuple(exports.int, exports.raw);
    return {
        container: 'versioned',
        description: function () { return "versioned({schema: " + args.schema.description() + ", migrations: ...})"; },
        read: function (_o) {
            var o = inner.read(_o);
            var ver = o[0];
            var data = o[1];
            // apply data migrations
            while (ver < args.migrations.length) {
                data = args.migrations[ver](data);
                ver++;
            }
            return args.schema.read(data);
        },
        write: function (t) { return inner.write([args.migrations.length /* version */, args.schema.write(t)]); }
    };
}
exports.versioned = versioned;
exports.dateUnixSecs = {
    container: 'none',
    description: function () { return 'dateUnixSecs'; },
    read: function (o) {
        // @ts-ignore hmm look into this XXX
        var d = new Date(typeof o == 'number' ? o * 1000.0 : (o instanceof Date ? o : (0, exports.validationError)('', o)));
        return isNaN(d.getTime()) ? (0, exports.validationError)('', o) : d;
    },
    write: function (t) {
        return t instanceof Date
            ? t.getTime() / 1000.0
            : (0, exports.validationError)('', t);
    }
};
exports.dateUnixMillis = {
    container: 'none',
    description: function () { return 'dateUnixMillis'; },
    read: function (o) {
        // @ts-ignore
        var d = new Date(typeof o == 'number' ? o : (o instanceof Date ? o : (0, exports.validationError)("", o)));
        return isNaN(d.getTime()) ? (0, exports.validationError)('', o) : d;
    },
    write: function (t) {
        return t instanceof Date
            ? t.getTime()
            : (0, exports.validationError)('', t);
    }
};
exports.dateIso = {
    container: 'none',
    description: function () { return 'dateIso'; },
    read: function (o) {
        // @ts-ignore
        var d = new Date(typeof o == 'string' ? o : (o instanceof Date ? o : (0, exports.validationError)('', o)));
        return isNaN(d.getTime()) ? (0, exports.validationError)('', o) : d;
    },
    write: function (t) {
        return t instanceof Date
            ? t.toISOString()
            : (0, exports.validationError)('', t);
    }
};
exports.str = {
    container: 'none',
    description: function () { return 'str'; },
    read: function (o) {
        return typeof o == 'string' ? o : (0, exports.validationError)('', o);
    },
    write: function (t) {
        return typeof (t) == 'string'
            ? t
            : (0, exports.validationError)('', t);
    }
};
exports.nothing = {
    container: 'none',
    description: function () { return 'nothing'; },
    read: function (o) { },
    write: function (o) { return ''; }
};
exports.bool = {
    container: 'none',
    description: function () { return 'bool'; },
    read: function (o) { return typeof o == 'boolean' ? o : (0, exports.validationError)('', o); },
    write: function (o) {
        return typeof (o) == 'boolean'
            ? o
            : (0, exports.validationError)('', o);
    }
};
exports.int = {
    container: 'none',
    description: function () { return 'int'; },
    read: function (o) {
        var i = parseInt(o);
        return isNaN(i) ? (0, exports.validationError)('', o) : i;
    },
    write: function (o) {
        return typeof (o) == 'number' && isFinite(o)
            ? Math.trunc(o)
            : (0, exports.validationError)('', o);
    }
};
exports.float = {
    container: 'none',
    description: function () { return 'float'; },
    read: function (o) {
        var i = parseFloat(o);
        return isNaN(i) ? (0, exports.validationError)('', o) : i;
    },
    write: function (o) {
        // NaN, Infinity can't be represented in JSON, so we reject those
        return typeof (o) == 'number' && isFinite(o)
            ? o
            : (0, exports.validationError)('', o);
    }
};
exports.raw = {
    container: 'none',
    description: function () { return 'raw'; },
    read: function (o) { return o; },
    write: function (o) { return o; }
};
var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
exports.uuid = {
    container: 'none',
    description: function () { return 'uuid'; },
    read: function (o) {
        return typeof o == 'string' && o.match(UUID_REGEX)
            ? o
            : (0, exports.validationError)('', o);
    },
    write: function (t) {
        return typeof t == 'string' && t.match(UUID_REGEX)
            ? t
            : (0, exports.validationError)('', t);
    }
};
function optional(s) {
    return {
        container: 'none',
        description: function () { return 'optional(' + s.description() + ')'; },
        read: function (o) { return o == null ? undefined : s.read(o); },
        write: function (t) { return t == null ? null : s.write(t); }
    };
}
exports.optional = optional;
function nullable(s) {
    return {
        container: 'none',
        description: function () { return 'nullable(' + s.description() + ')'; },
        read: function (o) { return o == null ? null : s.read(o); },
        write: function (t) { return t == null ? null : s.write(t); }
    };
}
exports.nullable = nullable;
function array(s) {
    return {
        container: 'list',
        description: function () { return "array(".concat(s.description(), ")"); },
        read: function (o) {
            if (!(o instanceof Array))
                (0, exports.validationError)('', o);
            var out = [];
            for (var i = 0; i < o.length; i++) {
                try {
                    out.push(s.read(o[i]));
                }
                catch (e) {
                    if (e instanceof ValidationError) {
                        return (0, exports.validationError)('[' + i + ']' + e.path, o);
                    }
                    throw e;
                }
            }
            return out;
        },
        write: function (o) {
            if (o instanceof Array) {
                var out = [];
                for (var i = 0; i < o.length; i++) {
                    try {
                        out.push(s.write(o[i]));
                    }
                    catch (e) {
                        if (e instanceof ValidationError) {
                            return (0, exports.validationError)('[' + i + ']' + e.path, o);
                        }
                        throw e;
                    }
                }
                return out;
            }
            else {
                (0, exports.validationError)('', o);
            }
        }
    };
}
exports.array = array;
function obj(def) {
    var read = function (o) {
        if (!(o instanceof Object) || (o instanceof Array)) {
            return (0, exports.validationError)('', o);
        }
        var out = {};
        for (var _i = 0, _a = Object.keys(def); _i < _a.length; _i++) {
            var key = _a[_i];
            try {
                out[key] = def[key].read(o[key]);
            }
            catch (e) {
                if (e instanceof ValidationError) {
                    return (0, exports.validationError)('.' + key + e.path, o);
                }
                throw e;
            }
        }
        return out;
    };
    var write = function (r) {
        if (!(r instanceof Object))
            return (0, exports.validationError)('', r);
        var out = {};
        for (var _i = 0, _a = Object.keys(def); _i < _a.length; _i++) {
            var key = _a[_i];
            try {
                out[key] = def[key].write(r[key]);
            }
            catch (e) {
                if (e instanceof ValidationError) {
                    return (0, exports.validationError)('.' + key + e.path, r);
                }
                throw e;
            }
        }
        return out;
    };
    return {
        container: 'obj',
        description: function () { return "obj({".concat(Object.keys(def).map(function (k) { return "".concat(k, ": ").concat(def[k].description()); }).join(', '), "})"); },
        read: read,
        write: write,
    };
}
exports.obj = obj;
/**
 * Like obj, but all properties are optional
 */
function partial_obj(def) {
    var read = function (o) {
        if (!(o instanceof Object) || (o instanceof Array)) {
            return (0, exports.validationError)('', o);
        }
        var out = {};
        for (var _i = 0, _a = Object.keys(def); _i < _a.length; _i++) {
            var key = _a[_i];
            try {
                out[key] = optional(def[key]).read(o[key]);
            }
            catch (e) {
                if (e instanceof ValidationError) {
                    return (0, exports.validationError)('.' + key + e.path, o);
                }
                throw e;
            }
        }
        return out;
    };
    var write = function (r) {
        if (!(r instanceof Object) || (r instanceof Array)) {
            return (0, exports.validationError)('', r);
        }
        var out = {};
        for (var _i = 0, _a = Object.keys(def); _i < _a.length; _i++) {
            var key = _a[_i];
            try {
                out[key] = optional(def[key]).write(r[key]);
            }
            catch (e) {
                if (e instanceof ValidationError) {
                    return (0, exports.validationError)('.' + key + e.path, r);
                }
                throw e;
            }
        }
        return out;
    };
    return {
        container: 'obj',
        description: function () { return "partial_obj({".concat(Object.keys(def).map(function (k) { return "".concat(k, ": ").concat(def[k].description()); }).join(', '), "})"); },
        read: read,
        write: write,
    };
}
exports.partial_obj = partial_obj;
function tuple() {
    var def = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        def[_i] = arguments[_i];
    }
    return {
        container: 'tuple',
        description: function () { return "tuple(" + def.map(function (d) { return d.description(); }).join(', ') + ")"; },
        read: function (o) {
            if (o instanceof Array) {
                var out = [];
                var i = 0;
                try {
                    for (; i < o.length; i++) {
                        out.push(def[i].read(o[i]));
                    }
                }
                catch (e) {
                    if (e instanceof ValidationError) {
                        return (0, exports.validationError)('[' + i + ']' + e.path, o);
                    }
                    throw e;
                }
                return out;
            }
            else {
                return (0, exports.validationError)('', o);
            }
        },
        write: function (r) {
            if (r instanceof Array) {
                var out = [];
                var i = 0;
                try {
                    for (; i < r.length; i++) {
                        out.push(def[i].write(r[i]));
                    }
                }
                catch (e) {
                    if (e instanceof ValidationError) {
                        return (0, exports.validationError)('[' + i + ']' + e.path, r);
                    }
                    throw e;
                }
                return out;
            }
            else {
                return (0, exports.validationError)('', r);
            }
        }
    };
}
exports.tuple = tuple;
// @ts-ignore
function oneOf() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return {
        container: 'sumtype',
        description: function () { return 'oneOf(' + args.map(function (k) { return "\"".concat(k, "\""); }).join(', ') + ')'; },
        read: function (o) {
            if (args.indexOf(o) != -1) {
                return o;
            }
            else {
                return (0, exports.validationError)('', o);
            }
        },
        write: function (t) {
            return args.indexOf(t) != -1
                ? t
                : (0, exports.validationError)('', t);
        }
    };
}
exports.oneOf = oneOf;
// @ts-ignore
function variant() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var variantTypes = args.filter(function (v, i) { return i % 2 == 0; });
    var variantSerializers = args.filter(function (v, i) { return i % 2 != 0; });
    // @ts-ignore
    return {
        description: function () {
            return "variant(".concat(variantTypes.map(function (t, i) {
                return "\"".concat(t, "\", ").concat(variantSerializers[i].description());
            }).join(', '), ")");
        },
        read: function (o) {
            var i = variantTypes.indexOf(o.type);
            if (i == -1) {
                return (0, exports.validationError)('', o);
            }
            else {
                try {
                    return __assign(__assign({}, variantSerializers[i].read(o)), { type: o.type });
                }
                catch (e) {
                    if (e instanceof ValidationError) {
                        return (0, exports.validationError)('<' + o.type + '>' + e.path, o);
                    }
                    else
                        throw e;
                }
            }
        },
        write: function (t) {
            var i = variantTypes.indexOf(t.type);
            if (i == -1) {
                return (0, exports.validationError)('', t);
            }
            else {
                try {
                    return __assign(__assign({}, variantSerializers[i].write(t)), { type: t.type });
                }
                catch (e) {
                    if (e instanceof ValidationError) {
                        return (0, exports.validationError)('<' + t.type + '>' + e.path, t);
                    }
                    else
                        throw e;
                }
            }
        }
    };
}
exports.variant = variant;
// @ts-ignore
function combine() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return {
        container: 'obj',
        description: function () { return "combine(".concat(args.map(function (a) { return a.description(); }).join(','), ")"); },
        read: function (o) { return Object.assign.apply(Object, __spreadArray([{}], args.map(function (_t) { return _t.read(o); }), false)); },
        write: function (o) { return Object.assign.apply(Object, __spreadArray([{}], args.map(function (_t) { return _t.write(o); }), false)); },
    };
}
exports.combine = combine;
exports.Result = require("./result");
